import React, { useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";

const TYPES = [
  {
    id: "general",
    label: "General",
    sub: "Recommended",
    tip: presetTip('General — "Recommended"', [
      "Handles everyday soft focus and mild blur",
      "Safe starting point for most photos",
    ]),
  },
  {
    id: "motion",
    label: "Motion",
    sub: "Camera shake",
    tip: presetTip('Motion — "Camera shake"', [
      "Targets streaky motion blur",
      "Useful for handheld or moving subjects",
    ]),
  },
  {
    id: "soft",
    label: "Soft focus",
    sub: "Out of focus",
    tip: presetTip('Soft focus — "Out of focus"', [
      "Recovers detail from soft / misfocused shots",
    ]),
  },
];

const STRENGTHS = [
  {
    id: "subtle",
    label: "Subtle",
    sub: "Light",
    tip: presetTip('Subtle — "Light"', [
      "Gentle sharpening",
      "Lowest risk of artifacts",
    ]),
  },
  {
    id: "balanced",
    label: "Balanced",
    sub: "Recommended",
    tip: presetTip('Balanced — "Recommended"', [
      "Noticeable clarity without heavy crunch",
    ]),
  },
  {
    id: "strong",
    label: "Strong",
    sub: "Max",
    tip: presetTip('Strong — "Max"', [
      "Aggressive deblur",
      "Best for very soft sources",
    ]),
  },
];

/**
 * AI Tools → AI Unblur prep.
 */
const UnblurToolPrep = (props) => {
  const [typeId, setTypeId] = useState("general");
  const [strengthId, setStrengthId] = useState("balanced");

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_unblur"
      title="AI Unblur"
      aka="Deblur"
      bio="Sharpen soft or motion-blurred photos with AI."
      emptyPreviewLabel="Upload an image to preview unblur"
      loadingLabel="Unblurring…"
      emptyFooterHint="Upload an image, pick blur type and strength, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Blur type</p>
            <AiPresetCards
              presets={TYPES}
              selectedId={typeId}
              ariaLabel="Blur type"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setTypeId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <p className="aftp-label">Strength</p>
            <AiPresetCards
              presets={STRENGTHS}
              selectedId={strengthId}
              ariaLabel="Unblur strength"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setStrengthId(id);
              }}
            />
          </div>
        </>
      )}
    />
  );
};

export default UnblurToolPrep;
